import { X } from "lucide-react";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { formatMoneyCents } from "@/core/utils/money";
import type { StAdjustmentTechnicianGroup } from "./types";

interface TechnicianSidebarHeaderProps {
  group: StAdjustmentTechnicianGroup;
  onClose: () => void;
}

export const TechnicianSidebarHeader = ({
  group,
  onClose,
}: TechnicianSidebarHeaderProps) => (
  <Stack
    direction="row"
    align="center"
    justify="between"
    fullWidth
    gap="sm"
    className="shrink-0 border-b border-stroke-tertiary px-5 py-4"
  >
    <Stack gap="none">
      <Typography variant="subtitleW3">
        {group.technicianName ??
          (group.employee_id == null
            ? "Unknown technician"
            : `Technician #${group.employee_id}`)}
      </Typography>
      <Typography variant="captionW1" textColor="secondary">
        {group.technicianName && `#${group.employee_id} · `}
        {group.pending} to push ·{" "}
        {formatMoneyCents(group.pending_amount_cents) ?? "$0"}
        {group.pushed > 0 && ` · ${group.pushed} already pushed`}
      </Typography>
    </Stack>
    <button
      type="button"
      aria-label="Close technician detail"
      onClick={onClose}
      className="shrink-0 cursor-pointer text-secondary-text transition-colors hover:text-primary-text focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
    >
      <X className="size-5" />
    </button>
  </Stack>
);
